import { green, red } from '@mui/material/colors';
import { ToggleButton, styled } from '@/theme/index';

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  flex: 1,
  justifyContent: 'center',
  backgroundColor: '#00000066',
  color: theme.palette.primary.contrastText,
  border: '1px solid #FFFFFF1A',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  borderBottom: 0,
  padding: 0,
  height: 'inherit',

  [theme.breakpoints.up('sm')]: {
    height: '3.5rem',
  },

  '&.Mui-selected': {
    backgroundColor: '#FFFFFF1F',
    color: theme.palette.primary.contrastText,

    '&:hover': {
      backgroundColor: '#FFFFFF1F',
    },

    '.green': {
      borderWidth: '2px',
      borderColor: green[500],
    },

    '.yellow': {
      borderWidth: '2px',
      borderColor: theme.palette.warning.light,
    },

    '.red': {
      borderWidth: '2px',
      borderColor: red[400],
    },
  },

  '&.Mui-disabled': {
    border: '1px solid #FFFFFF1A',
  },
}));
